module.exports = __webpack_public_path__ + "static/media/fillcolor.9af8e352.svg";